/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IUserState {
  email: string;
  pin: string;
  password: string;
  phone: string;
  firstName: string;
  lastName: string;
  notifications: any;
  referralCode: string;
}

const initialState: IUserState = {
  email: '',
  pin: '',
  password: '',
  phone: '',
  firstName: '',
  lastName: '',
  notifications: null,
  referralCode: ''
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setEmail: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.email = payload;
    },
    setPin: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.pin = payload;
    },
    setPassword: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.password = payload;
    },
    setPhone: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.phone = payload;
    },
    setFirstName: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.firstName = payload;
    },
    setLastName: (state: IUserState, action: PayloadAction<string>) => {
      const { payload } = action;
      state.lastName = payload;
    },
    setNotifications: (state: IUserState, action: PayloadAction<any>) => {
      const { payload } = action;
      state.notifications = payload;
    },
    setReferralCode: (state: IUserState, action: PayloadAction<any>) => {
      const { payload } = action;
      state.referralCode = payload;
    }
  }
});

const { actions, reducer } = userSlice;
export const {
  setEmail,
  setPin,
  setPassword,
  setPhone,
  setFirstName,
  setLastName,
  setNotifications,
  setReferralCode
} = actions;
export default reducer;
